import React, { useMemo } from "react";
import {
  SFHeroCard,
  SFHeroTile,
  SFUseStyled,
  SFClientSideFilterActions,
} from "@sf-core";
import _ from "lodash";
import { Logger } from "@base-provider";
import {
  getProficiencyLevelLabel,
} from "../../../../constants/proficiencyLevels";
import { useTranslation } from "react-i18next";
import { Flag, Arrow } from "../icons";
import { useDispatch, useSelector } from "react-redux";
import { GRID_NAMES } from "../../../../constants/gridNames";

const { styled } = SFUseStyled();

const SkillListStyled = styled("ul")(({ theme }) => ({
  listStyle: "none",
  fontSize: 12,
  lineHeight: "18px",
  margin: 0,
  padding: 0,
  svg: {
    marginRight: 5,
  },
  span: {
    color: theme.palette.blue200.main,
    cursor: "pointer",
  },
}));

const MySkillsCard = ({ skills, actions }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const savedLayout = useSelector((state) => {
    return state.clientSideFilter.find(
      (clientSideFilter) => clientSideFilter.gridName === GRID_NAMES.DASHBOARD_MY_SKILLS
    );
  });
  const currentFilterModel = savedLayout?.state?.filter?.filterModel || [];
  const currentProficiencyLevels = currentFilterModel?.proficiencyLevel?.values || [];

  const skillsBreakdown = useMemo(() => {
    const grouped = _.groupBy(skills, "proficiencyLevel");
    const counts = _.map(grouped, (group, proficiencyLevel) => ({
      proficiencyLevel,
      count: group.length,
      icon:
      currentProficiencyLevels.includes(proficiencyLevel) ? (
        <Flag />
      ) : (
        <Arrow />
      ),
    }));
    return _.orderBy(
      counts.filter((a) => a.proficiencyLevel > 0),
      (item) => item.proficiencyLevel,
      "desc"
    );
  }, [skills, savedLayout]);

  Logger.of("App.MySkillsCard").info(skillsBreakdown);

  const onClick = (item) => {
    if (!currentProficiencyLevels.includes(item.proficiencyLevel)) {
      let newProficiencyLevels = [
        ...currentProficiencyLevels,
        item.proficiencyLevel,
      ];
      const payload = {
        gridName: GRID_NAMES.DASHBOARD_MY_SKILLS,
        state: {
          filter: {
            filterModel: {
              ...currentFilterModel,
              proficiencyLevel: {
                filterType: "set",
                values: newProficiencyLevels,
              },
            },
          },
        },
      };
      dispatch(SFClientSideFilterActions.saveState(payload));
    }
  };

  return (
    <SFHeroCard
      actions={actions}
      leftContent={
        <SFHeroTile title={_.size(skills)} subTitle={t("dashboardScreen.totalSkills")} />
      }
    >
      <SkillListStyled>
        {skillsBreakdown.map((item) => (
          <li>
            {item.icon} {t(getProficiencyLevelLabel(item.proficiencyLevel))}:{" "}
            <span onClick={() => onClick(item)}>{item.count}</span>
          </li>
        ))}
      </SkillListStyled>
    </SFHeroCard>
  );
};

export default MySkillsCard;
